export const getTaskTypeByRoutingType = (routingType) =>
  ({
    player: 'PLAYER',
    vsg: 'VSG',
    tracking: 'TRACKING',
  })[routingType];

export const getSdkBaseLib = () =>
  'const SDK = {' +
  'getVersion: () => {},' +
  'init: () => {},' +
  'checkVideoAvailability: (hash, product_id, callback) => {},' +
  'getBestVideo: (hash, product_id, callback) => {},' +
  'getVideos: (hash, product_id, callback) => {},' +
  'getAllVideos: (hash, callback) => {},' +
  'getVideoById: (hash, id, callback) => {},' +
  'preloadVideos: (hash, force) => {},' +
  'flushCache: () => {},' +
  'isCacheReady: (hash) => {},' +
  'addEventListener: (type = "*", func) => {},' +
  'removeEventListener: (type = "*", func) => {},' +
  'isConsentGranted: () => {},' +
  'customIntegration: () => {},' +
  '};';
